import React from 'react'
import {IBrandModel} from './BrandModel'
import DataTable, {TableAction, TableColumn} from '../../../../shared/components/DataTable'

type Props = {
  data: IBrandModel[]
  currentPage: number
  totalPages: number
  onPageChange: (page: number) => void
  onEdit?: (brand: IBrandModel) => void
  onDelete?: (brand: IBrandModel) => void
  loading?: boolean
}

export const BrandTable: React.FC<Props> = ({
  data,
  currentPage,
  totalPages,
  onPageChange,
  onEdit,
  onDelete,
  loading = false,
}) => {
  const columns: TableColumn<IBrandModel>[] = [
    {key: 'name', label: 'Marka Adı', className: 'fw-semibold'},
  ]

  const actions: TableAction<IBrandModel>[] = [
    {
      label: 'Düzenle',
      icon: 'bi bi-pencil',
      className: 'btn-light-primary me-2',
      onClick: (brand) => onEdit?.(brand),
    },
    {
      label: 'Sil',
      icon: 'bi bi-trash',
      className: 'btn-light-danger',
      onClick: (brand) => onDelete?.(brand),
    },
  ]

  return (
    <DataTable
      data={data}
      columns={columns}
      actions={actions}
      showPagination={true}
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={onPageChange}
      loading={loading}
      emptyMessage='Henüz marka bulunamadı'
    />
  )
}
